package com.ijoin.payment

import androidx.compose.ui.graphics.Color
import com.ijoin.ui.design.EventCardAccent
import com.ijoin.ui.design.EventCardAccentDark
import com.ijoin.ui.design.EventCardAlert
import com.ijoin.ui.design.EventCardBackground
import com.ijoin.ui.design.EventCardCorner
import com.ijoin.ui.design.EventCardOutline
import com.ijoin.ui.design.EventCardPillCorner
import com.ijoin.ui.design.EventCardPrimaryButtonText
import com.ijoin.ui.design.EventCardRailContent
import com.ijoin.ui.design.EventCardSurface
import kotlin.math.roundToInt

data class StripeOverlayStyle(
    val background: String,
    val surface: String,
    val text: String,
    val textMuted: String,
    val border: String,
    val primary: String,
    val onPrimary: String,
    val primaryShadow: String,
    val error: String,
    val overlay: String,
    val shadow: String,
    val radius: String,
    val radiusPill: String,
)

fun stripeOverlayStyle(): StripeOverlayStyle {
    val text = EventCardAccentDark.toCssHex()
    val textMuted = EventCardRailContent.toCssHex()
    val overlay = EventCardAccentDark.toCssRgba(0.35f)
    val shadow = "0 24px 60px ${EventCardAccentDark.toCssRgba(0.25f)}"
    return StripeOverlayStyle(
        background = EventCardBackground.toCssHex(),
        surface = EventCardSurface.toCssHex(),
        text = text,
        textMuted = textMuted,
        border = EventCardOutline.toCssHex(),
        primary = EventCardAccent.toCssHex(),
        onPrimary = EventCardPrimaryButtonText.toCssHex(),
        primaryShadow = EventCardAccent.toCssRgba(0.35f),
        error = EventCardAlert.toCssHex(),
        overlay = overlay,
        shadow = shadow,
        radius = "${EventCardCorner.value.toInt()}px",
        radiusPill = "${EventCardPillCorner.value.toInt()}px",
    )
}

private fun Color.toCssHex(): String {
    val r = (red * 255f).roundToInt().coerceIn(0, 255)
    val g = (green * 255f).roundToInt().coerceIn(0, 255)
    val b = (blue * 255f).roundToInt().coerceIn(0, 255)
    return "#${r.toHex2()}${g.toHex2()}${b.toHex2()}"
}

private fun Color.toCssRgba(alpha: Float): String {
    val r = (red * 255f).roundToInt().coerceIn(0, 255)
    val g = (green * 255f).roundToInt().coerceIn(0, 255)
    val b = (blue * 255f).roundToInt().coerceIn(0, 255)
    return "rgba($r, $g, $b, ${alpha.coerceIn(0f, 1f)})"
}

private fun Int.toHex2(): String = toString(16).padStart(2, '0')
